
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"200","height":"120","viewBox":"0 0 52.917 31.75","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.214 8.38A22.49 20.24 0 003.969 25.908h44.979a22.49 20.24 0 00-11.245-17.53 22.49 20.24 0 00-22.49 0z","fill":"#f5f5f5","stroke":"gray","stroke-width":".5"}}),_c('path',{attrs:{"d":"M11.268 22.546a16.487 15.736 0 0112.63-10.115","fill":"none","stroke":"#45bd02","stroke-width":"8"}}),_c('path',{attrs:{"opacity":".99","stroke":"#f5f5f5","stroke-width":".601","d":"M14.693 15.512l1.7-1.699 9.813 9.814-1.699 1.7z"}}),_c('path',{attrs:{"d":"M29.462 25.909a3.004 3.004 0 00-1.502-2.602 3.004 3.004 0 00-3.004 0 3.004 3.004 0 00-1.502 2.602","stroke":"#f5f5f5","stroke-width":".529"}})])
          )
        }
      }
    